import { gql } from "@apollo/client";

export const NEW_MESSAGE_SUBSCRIPTION = gql`
  subscription newMessage {
    newMessage {
      _id
      channelId
      type
      message
      senderId
      read
      sender {
        _id
        role
        firstName
      }
      channel {
        _id
        memberIds
        members {
          _id
          email
          firstName
          lastName
          totalLikes
          createdAt
        }
      }
    }
  }
`;
